// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__ReO3A","subheader":"ReorderModal_subheader__1rxf3","listWrap":"ReorderModal_listWrap__KpVkL"};